export const dateToString = (date) => {
  const isoDate = date.toISOString(); // "2023-04-24T06:21:49.123Z"
  const formattedDate = isoDate.slice(0, 10).replace(/-/g, ""); //"20230424"
  return formattedDate;
};
